var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('router-view',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],attrs:{"name":"sidebar"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }